import { createAction, props } from '@ngrx/store';
import { ResponseClientStatePasswordGet } from '../../shared/interfaces';
import { ClientStatePasswordGetTypes } from '../../shared/enums';

export const getClientStatePasswordGet = createAction(
    ClientStatePasswordGetTypes.CLIENT_STATE_PASSWORD_GET
);

export const getClientStatePasswordGetSuccess = createAction(
    ClientStatePasswordGetTypes.CLIENT_STATE_PASSWORD_GET_SUCCESS,
    props<{ response: ResponseClientStatePasswordGet }>()
);

export const getClientStatePasswordGetError = createAction(
    ClientStatePasswordGetTypes.CLIENT_STATE_PASSWORD_GET_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    ClientStatePasswordGetTypes.CLEAN_STATE
);

